/* eslint-disable prefer-arrow-callback */
(function Mosaic(window) {
  const mosaics = Array.prototype.slice.call(
    window.document.querySelectorAll('.tc_tools__mosaic:not([data-processed])')
  );

  Array.prototype.forEach.call(mosaics, function mosaicLoop(mosaic) {
    const mosaicItems = Array.prototype.slice.call(
      mosaic.querySelectorAll('.tc_tools__mosaic__item')
    );

    Array.prototype.forEach.call(mosaicItems, function mosaicItemLoop(
      mosaicItem,
    ) {
      let prevButton = null;
      let nextButton = null;

      // close other <details> if new is opened
      mosaicItem
        .querySelector('.tc_tools__mosaic__item__header')
        .addEventListener('click', function clickHandler() {
          if (!this.parentNode.hasAttribute('open')) {
            mosaicItems.forEach(function removeOpen(details) {
              details.removeAttribute('open');
            });
          }

          // Support for standard <details> toggling in older browsers
          if (!('open' in document.createElement('details'))) {
            if (!this.parentNode.hasAttribute('open')) {
              this.parentNode.setAttribute('open', 'open');
            } else {
              this.parentNode.removeAttribute('open');
            }
          }
        });

      // Arrow navigation
      if (mosaic.hasAttribute('data-widget-arrows')) {
        prevButton = mosaicItem.querySelector(
          '.tc_tools__mosaic__item__arrows__prev',
        );
        if (prevButton !== null) {
          prevButton.addEventListener('click', function prevButtonHandler() {
            mosaicItem.previousElementSibling
              .querySelector('.tc_tools__mosaic__item__header')
              .click();
          });
        }
        nextButton = mosaicItem.querySelector(
          '.tc_tools__mosaic__item__arrows__next',
        );
        if (nextButton !== null) {
          nextButton.addEventListener('click', function prevButtonHandler() {
            mosaicItem.nextElementSibling
              .querySelector('.tc_tools__mosaic__item__header')
              .click();
          });
        }
      }
    });
    mosaic.setAttribute('data-processed', 'true');
  });
})(window);
